(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["complete-the-rotation"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initCompleteRotationNav() {
    var sections = document.querySelectorAll('.complete-rotation');
    sections.forEach(function(section) {
      var prevBtn = section.querySelector('[name="prev"]');
      var nextBtn = section.querySelector('[name="next"]');
      var grid = section.querySelector('.product-grid');
      if (!prevBtn || !nextBtn || !grid) return;

      nextBtn.addEventListener('click', function() {
        grid.scrollBy({ left: grid.offsetWidth, behavior: 'smooth' });
      });
      prevBtn.addEventListener('click', function() {
        grid.scrollBy({ left: -grid.offsetWidth, behavior: 'smooth' });
      });
    });
  }

  /* Moves the "Save $X" badge off the price row and onto the product image,
     bottom-centered, so it reads as an image badge instead of price text. */
  function initCompleteRotationSaveBadge() {
    var sections = document.querySelectorAll('.complete-rotation');
    sections.forEach(function(section) {
      var blocks = section.querySelectorAll('.product-block');
      blocks.forEach(function(block) {
        var badge = block.querySelector('.price__save-badge');
        var imageWrap = block.querySelector('.image-label-wrap');
        if (badge && imageWrap && badge.parentElement !== imageWrap) {
          imageWrap.appendChild(badge);
        }
      });
    });
  }

  function initCompleteRotation() {
    initCompleteRotationNav();
    initCompleteRotationSaveBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCompleteRotation);
  } else {
    initCompleteRotation();
  }

  document.addEventListener('shopify:section:load', function() {
    initCompleteRotation();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cstm-mf-collection-list"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCarousel(root) {
    var track = root.querySelector("[data-cc-track]");
    if (!track) return;

    var prev = root.querySelector("[data-cc-prev]");
    var next = root.querySelector("[data-cc-next]");

    function step() {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth;
      var gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap, 10) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      if (prev) prev.disabled = track.scrollLeft <= 0;
      if (next) next.disabled = track.scrollLeft >= maxScroll;
    }

    if (prev) prev.addEventListener("click", function () {
      track.scrollBy({ left: -step(), behavior: "smooth" });
    });
    if (next) next.addEventListener("click", function () {
      track.scrollBy({ left: step(), behavior: "smooth" });
    });

    track.addEventListener("scroll", updateArrows, { passive: true });
    window.addEventListener("resize", updateArrows);
    updateArrows();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll("[data-coll-carousel]").forEach(initCarousel);
  }

  if (document.readyState !== "loading") initAll();
  else document.addEventListener("DOMContentLoaded", function () { initAll(); });
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
      // Bind arrow navigation after content loads
      initRelatedCarouselNav(productRecommendationsSection);
      initRelatedSaveBadge(productRecommendationsSection);
    }
  };
  request.send();
};

/* Moves the "Save $X" badge off the price row and onto the product image,
   bottom-centered, so it reads as an image badge instead of price text.
   Mirrors the Complete the rotation section. */
function initRelatedSaveBadge(section) {
  section.querySelectorAll('.product-block').forEach(function(block) {
    var badge = block.querySelector('.price__save-badge');
    var imageWrap = block.querySelector('.image-label-wrap');
    if (badge && imageWrap && badge.parentElement !== imageWrap) {
      imageWrap.appendChild(badge);
    }
  });
}

function initRelatedCarouselNav(section) {
  var prevBtn = section.querySelector('[name="prev"]');
  var nextBtn = section.querySelector('[name="next"]');
  var grid = section.querySelector('.product-grid');
  if (!prevBtn || !nextBtn || !grid) return;

  nextBtn.addEventListener('click', function() {
    grid.scrollBy({ left: grid.offsetWidth, behavior: 'smooth' });
  });
  prevBtn.addEventListener('click', function() {
    grid.scrollBy({ left: -grid.offsetWidth, behavior: 'smooth' });
  });
}

// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
